// Login
import React, { useEffect, useState } from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './util/authconfig';

import GenericAI from './pages/ai';
import Login from './pages/login';

function App() {
  const [isAuthorised, setIsAuthorised] = useState(true);
  const [user, setUser] = useState({
    username: "",
    id: ""
  });

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  useEffect(() => {
    // Checks if initial user state is empty
    if (!user.username) {
      const userEmail = activeAccount?.username;
      if (userEmail) {
        // Handle SSO session
        const id = activeAccount.idTokenClaims.oid // oid is the constant ID from Entra
        setUser({
          username: userEmail,
          id: id
        });
        setIsAuthorised(true);
      } else {
        setIsAuthorised(false);
      }
    }
  }, [activeAccount, isAuthorised, user.username]);

  // Handle SSO login
  const handleLoginRedirect = () => {
    return instance.loginRedirect({
        ...loginRequest,
        prompt: 'create',
    })
    .then(() => {
      window.location.reload();
    })
    .catch((error) => {
      console.log(error);
      setIsAuthorised(false);
    });
  };

  const handleLogoutRedirect = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: '/'
    })
    .then(() => {
      setIsAuthorised(false);
    })
    window.location.reload();
  };

  const authProps = {
    user, isAuthorised
  }

  const UnauthenticatedRoutes = () => (
    <Router>
      <Routes>
        <Route path="/" element={<Login authProps={authProps} handleLoginRedirect={handleLoginRedirect} />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );

  const AuthenticatedRoutes = () => (
    <Router>
      <Routes>
        <Route path="/" element={<GenericAI authProps={authProps} handleLogoutRedirect={handleLogoutRedirect} />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );

  return (
    isAuthorised ?
      <AuthenticatedRoutes />
    :
      <UnauthenticatedRoutes />
  );
}

export default App;

// To bypass login and set a demo user, 
// use the following code instead of the above


// import React, { useEffect, useState } from 'react';
// import './App.css';
// import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

// import GenericAI from './pages/ai';
// import Login from './pages/login';

// function App() {
//   const [isAuthorised, setIsAuthorised] = useState(true);
//   const [user, setUser] = useState({
//     username: "",
//     id: ""
//   });

//   useEffect(() => {
//     // Bypass login and set a demo user
//     setUser({
//       username: "demo_user@example.com",
//       id: "demo_user_id"
//     });
//     setIsAuthorised(true);
//   }, []);

//   const handleLogoutRedirect = () => {
//     setIsAuthorised(false);
//     setUser({
//       username: "",
//       id: ""
//     });
//   };

//   const authProps = {
//     user, isAuthorised
//   };

//   const UnauthenticatedRoutes = () => (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Login authProps={authProps} />} />
//         <Route path="*" element={<Navigate to="/" />} />
//       </Routes>
//     </Router>
//   );

//   const AuthenticatedRoutes = () => (
//     <Router>
//       <Routes>
//         <Route path="/" element={<GenericAI authProps={authProps} handleLogoutRedirect={handleLogoutRedirect} />} />
//         <Route path="*" element={<Navigate to="/" />} />
//       </Routes>
//     </Router>
//   );

//   return (
//     isAuthorised ?
//       <AuthenticatedRoutes />
//     :
//       <UnauthenticatedRoutes />
//   );
// }

// export default App;